<div class="card-view-header-attachment-count">
  <app-icon-attachment></app-icon-attachment>
  <app-badge value="{{ count }}"></app-badge>
</div>
